"use client";

import { useQuery } from "@tanstack/react-query";

import { viewerContextQueryOptions } from "@/lib/viewer-context";
import { snapshotToQueryData } from "@/utils/session";

export function useSession() {
  return useQuery({
    ...viewerContextQueryOptions(),
    select: (viewer) => snapshotToQueryData({ user: viewer.user }),
  });
}
